import Joi from "joi";

export const JoiTenantTokenScheme = Joi.object({
  created_at: Joi.string().required().allow(""),
  id: Joi.number().required(),
  name: Joi.string().required().allow(""),
  status: Joi.boolean().optional(),
  tenant_id: Joi.number().required(),
  updated_at: Joi.string().required().allow(""),
});
